<template>
  <div class="addTextLive">
    <el-breadcrumb class="bread-nav" separator="/">
      <el-breadcrumb-item>首页</el-breadcrumb-item>
      <el-breadcrumb-item>互动直播</el-breadcrumb-item>
      <el-breadcrumb-item>添加直播</el-breadcrumb-item>
    </el-breadcrumb>
    <el-form ref="form" :model="form" :rules="editRules" label-width="80px">
        <el-form-item label="直播标题" prop="liveTitle">
            <el-input v-model="form.liveTitle"></el-input>
        </el-form-item>
        <el-form-item label="投放公司" prop="fromCompany">
            <el-input v-model="form.fromCompany"></el-input>
        </el-form-item>
        <el-form-item label="执行者" prop="userId">
            <el-select v-model="form.userId" placeholder="请选择执行">
            <el-option v-for="item in userList" :key="item.userId" :label="item.userName" :value="item.userId"></el-option>
            </el-select>
        </el-form-item>
        <el-form-item label="" prop="isOpenComment">
            <el-checkbox v-model="form.isOpenComment" :true-label="1" :false-label="0">开启评论</el-checkbox>
        </el-form-item>
        <el-form-item label="直播源" prop="liveSource">
            <el-select @change="changeLiveSource()" v-model="form.liveSource" placeholder="请选择直播源">
            <el-option v-for="item in form.liveSourceList" :key="item.name" :label="item.name" :value="item"></el-option>
            </el-select>
        </el-form-item>
        <el-form-item label="缩略图" prop="otherImg">
            <el-input v-model="form.otherImg" :disabled="!form.liveSource.otherImg" placeholder="背景图链接（尺寸16：9）"></el-input>
        </el-form-item>
        <el-form-item label="直播链接" prop="liveUrl">
            <el-input v-model="form.liveUrl" :disabled="!form.liveSource.name"></el-input>
        </el-form-item>
        <el-form-item label="直播描述" prop="liveContent">
            <el-input type="textarea" :rows="2" placeholder="请输入直播描述" v-model="form.liveContent"></el-input>
        </el-form-item>
        <el-form-item label="" prop="isShare">
            <el-checkbox v-model="form.isShare" @change="changeShare()">开启分享</el-checkbox>
        </el-form-item>
        <el-form-item label="分享链接" prop="shareUrl">
            <el-input v-model="form.shareUrl" :disabled="!form.isShare" placeholder="请输入分享链接（选填）"></el-input>
        </el-form-item>
        <el-form-item label="分享头图" prop="shareImg">
            <el-input v-model="form.shareImg" :disabled="!form.isShare" placeholder="请输入分享头图，尺寸200x200（必填）"></el-input>
        </el-form-item>
        <el-form-item label="分享标题" prop="shareTitle">
            <el-input v-model="form.shareTitle" :disabled="!form.isShare" placeholder="请输入分享标题（必填）"></el-input>
        </el-form-item>
        <el-form-item label="分享描述" prop="shareDesc">
            <el-input v-model="form.shareDesc" :disabled="!form.isShare" placeholder="请输入分享描述（必填）"></el-input>
        </el-form-item>
        <el-form-item>
            <el-button type="primary" @click="submitForm()">立即创建</el-button>
            <el-button @click="resetForm('form')">重置</el-button>
        </el-form-item>
    </el-form>
  </div>
</template>
<script>
  import CONFIG from "@/config/index.js";
  import TOOL from '@/tool/index.js';
  import router from "@/router/index.js";
  import { mapGetters } from 'vuex';
  import co from 'co';
  export default {
    name: "ugcliveAdd",
    data() {
      return {
        userList:null,
        form:{
            liveTitle:'',
            fromCompany:'',
            isLiveBgImg:false,
            liveBgImg:'',
            liveSource:{},
            liveSourceList:[
                {name:'映客',otherImg:true,reg:/^https?\:\/\/.*inke\./},
                {name:'花椒',otherImg:true,reg:/^https?\:\/\/h\.huajiao\.com\//},
                {name:'优酷',otherImg:false,reg:/^https?\:\/\/vku\.youku\.com\//},
                {name:'一点资讯',otherImg:true,reg:/(?:^https?\:\/\/livepull\.go2yd\.com\/)|(?:^https?\:\/\/.+.mp4$)/},
                {name:'一直播',otherImg:true,reg:/^https?\:\/\/.*yizhibo\.com\//},
            ],
            otherImg:'',
            liveUrl:'',
            liveContent:'',
            isShare:false,
            shareUrl:'',
            shareImg:'',
            shareTitle:'',
            shareDesc:'',
            isOpenComment:1,
            userId:null
        },
        editRules:{
          liveTitle: [
            { required: true, message: '请输入直播标题'},
          ],
          fromCompany: [
            { required: true, message: '请输入投放公司'},
          ],
          userId: [
            { required: true, message: '请选择执行'},
          ],
          liveSource: [
            { required: true, message: '请选择直播源'},
            { validator: this._checkLiveSource, trigger: 'blur' }
          ],
          liveUrl: [
            { validator: this._checkLiveUrl, trigger: 'blur' }
          ],
          otherImg: [
            { validator: this._checkOtherImg, trigger: 'blur' }
          ],
          shareTitle: [
            { validator: this._checkShareTitle, trigger: 'blur' }
          ],
          shareDesc: [
            { validator: this._checkShareContent, trigger: 'blur' }
          ],
          shareImg: [
            { validator: this._checkShareImg, trigger: 'blur' }
          ],
        }
      }
    },
    filters: {

    },
    methods: {
      //创建图文直播
      submitForm(){
        let flag = true;
        this.$refs['form'].validate((valid) => {
          if (!valid) {
            flag = false;
            return false;
          }
        });
        if(!flag){
          return;
        }else{
          this.submitService();
        }
      },
      submitService(){
        var self = this;
        var form = this.form;
        var formData = Object.create(null);
        formData.liveTitle = form.liveTitle.trim();
        formData.creator = form.userId;
        formData.liveBgImg = null;
        formData.liveUrl = form.liveUrl.trim();
        formData.liveContent = form.liveContent;
        formData.fromCompany = form.fromCompany.trim();
        formData.isOpenComment = form.isOpenComment;
        formData.shareTitle = form.shareTitle;
        formData.shareDesc = form.shareDesc;
        formData.shareImg = form.shareImg;
        formData.shareUrl = form.shareUrl;
        formData.liveSource = "图文直播";
        formData.isShare = Number(form.isShare);
        formData.otherImg = form.otherImg;
        this.submitServiceCo(formData)()
        .catch(()=>{
            self.$notify.error({
              message: "添加图文直播失败"
            });
        });
      },
      submitServiceCo(formData){
        var self = this;
        function* gen(){
          var result = yield self.$http.post(CONFIG.HOST + '/live/addLive',formData);
          if(result.body.status===1){
            self.editDialog=false;
            self._init();
            self.resetForm('form');
            self.$notify.success({
              message: "添加成功"
            });
          }else{
            self.$notify.error({
              message: result.body.message
            });
          }
        }
        return co.wrap(gen);
      },
      //校验缩略图
      _checkOtherImg(rule, value, callback){
        if(!this.form.liveSource.otherImg){
          callback();
        }else{
          let reg = /^https?\:\/\/.*yidianzixun\.com/;
          if(reg.test(value)){
            callback();
          }else{
            callback(new Error('请输入以包含yidianzixun.com域名的图片链接'));
          }
        }
      },
      //校验必须选择直播源
      _checkLiveSource(rule, value, callback){
        if(!this.form.liveSource.reg){
            callback(new Error('请选择直播源'));
        }else{
            callback();
        }
      },
      //校验直播源
      _checkLiveUrl(rule, value, callback){
        if(!this.form.liveSource.reg||this.form.liveSource.reg.test(value)){
          callback();
        }else{
          callback(new Error('请输入'+this.form.liveSource.name+"平台的直播源链接"));
        }
      },
      //校验分享标题
      _checkShareTitle(rule, value, callback){
        if(!this.form.isShare){
          callback();
        }else{
          if(!value||!value.trim()){
            callback(new Error('请输入的分享标题'));
          }else{
            callback();
          }
        }
      },
      //校验分享描述
      _checkShareContent(rule, value, callback){
        if(!this.form.isShare){
          callback();
        }else{
          if(!value||!value.trim()){
            callback(new Error('请输入的分享描述'));
          }else{
            callback();
          }
        }
      },
      //校验分享头图
      _checkShareImg(rule, value, callback){
        if(!this.form.isShare){
          callback();
        }else{
          let reg = /^https?\:\/\/.*yidianzixun\.com/;
          if(reg.test(value)){
            callback();
          }else{
            callback(new Error('请输入以包含yidianzixun.com域名的图片链接'));
          }
        }
      },
      //开启、关闭分享时触发分享校验
      changeShare(){
        this.$refs['form'].validateField('shareTitle',(errmessage)=>{
          console.log(errmessage);
        });
        this.$refs['form'].validateField('shareDesc',(errmessage)=>{
          console.log(errmessage);
        });
        this.$refs['form'].validateField('shareImg',(errmessage)=>{
          console.log(errmessage);
        });
      },
      //直播源改变触发校验
      changeLiveSource(){
        this.$refs['form'].validateField('otherImg',(errmessage)=>{
          console.log(errmessage);
        });
        this.$refs['form'].validateField('liveUrl',(errmessage)=>{
          console.log(errmessage);
        });
      },
      //重置表单
      resetForm(formName) {
        this.$refs[formName].resetFields();
      },
      //组件进入工作状态的钩子函数
      _init(){
        this.$http.get(CONFIG.HOST + "/users/list").then((response)=>{
          let result = response.body;
          if (result && result.status === 1) {
            this.userList = result.data.filter(function(item){
                let reg = /^执行/;
                return reg.test(item.permissionsName);
            });
          } else {
            this.$notify.error({
              message: result.message
            });
          }
        }, (response)=>{
          console.log(response);
        });
      }
    },
    mounted(){
      this._init();
    }
  };
</script>
<style lang="less">
  .addTextLive{
    width: 80%;
    margin-top: 0;
    margin-left: 10px;
    position: relative;
    height: 100%;
    overflow: auto;
    .bread-nav{
      margin: 20px 0;
    }
    .el-form-item{
        text-align: left;
    }
  }
</style>


// WEBPACK FOOTER //
// Add.vue?c3cd142e